import React from 'react';
import { useTranslation } from 'react-i18next';

type ErrorProps = {
  title?: string;
  message?: string;
  onRetry?: () => void;
  showRetry?: boolean;
};

const Error: React.FC<ErrorProps> = ({
  title,
  message,
  onRetry,
  showRetry = true,
}) => {
  const { t } = useTranslation();
  const resolvedTitle = title ?? t('error.title', 'Something went wrong');
  const resolvedMessage = message ?? t('error.message', 'An unexpected error occurred while loading this content.');

  return (
    <div className="error-screen" role="alert">
      <div className="error-box">
        <h2 className="error-title">{resolvedTitle}</h2>
        <p className="error-message">{resolvedMessage}</p>
        {showRetry && onRetry && (
          <button className="btn btn-primary" onClick={onRetry}>
            {t('error.tryAgain', 'Try again')}
          </button>
        )}
      </div>
    </div>
  );
};

export default Error;
